import _ from 'lodash'

const getEarnStatusColor = (credit) => {
  let color = ""

  if (_.inRange(credit, 0, 5)) {
    color = "red"
  } else if (_.inRange(credit, 5, 10)) {
    color = "orange"
  } else if (_.inRange(credit, 10, 15)) {
    color = "olive"
  } else if (credit >= 15) {
    color ="green"
  }

  return color
}

export default getEarnStatusColor


// WEBPACK FOOTER //
// ./src/helpers/EarnStatus.js